<input
    [type]="type"
    [name]="name"
    [placeholder]="placeholder"
    [disabled]="disabled"
    [required]="isRequired"
    [value]="value"
    (input)="valueChange.emit($event.target.value)"
/>
